import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardContext from "../context/DashboardContext";
import MembersContext from "../context/MembersContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Container from "@mui/material/Container";
import CreateIcon from "@mui/icons-material/Create";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import IconButton from "@mui/material/IconButton";
import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import Stack from "@mui/material/Stack";
import { styled, useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { CircularProgress, Grid } from "@mui/material"; // Importação do Grid
import { TiDelete } from "react-icons/ti";
import {
  getWorkers,
  deleteWorkers,
} from "../services";

export default function Workers() {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [filterTextInput, setFilterTextInput] = useState("");
  const [isMemberActivationDialogOpen, setIsMemberActivationDialogOpen] = useState(false);
  const [allMembers, setAllMembers] = useState([]);
  const [memberSelectedCPF, setMemberSelectedCPF] = useState("");
  const [membersPage, setMembersPage] = useState(0);
  const [memberToBeActivatedCpf, setMemberToBeActivatedCpf] = useState("");
  const [isMembersNotFound, setIsMembersNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cpfError, setCpfError] = useState(false);
  const [idOnDelete, setIdOnDelete] = useState("");

  const {
    clientUser,
    clientPassword,
    clientId,
    setEditId,
    drawerWidth,
    isMemberDrawerOpen,
    setIsMemberDrawerOpen,
    setEditName,
    setEditCpf,
    token,
    typeClient,
    setTotalWorkers,
  } = useContext(DashboardContext);

  const navigation = useNavigate();

  const getAllMembers = async () => {
    const sendData = { pagination: membersPage, id: clientId };
    if (typeClient === "cpf") {
      sendData.token = token;
    } else {
      sendData.user = clientUser;
      sendData.password = clientPassword;
    }
    const response = await getWorkers(sendData);

    setIsLoading(false);

    if (response === "Error") {
      setAllMembers([]);
      setIsMembersNotFound(true);
    } else {
      setTotalWorkers(response?.length);
      setAllMembers(response);
      setIsMembersNotFound(false);
    }
  };

  const handleMemberActivationDialog = ({ currentTarget: { name: id } }) => {
    if (!!id) setIdOnDelete(id);
    setIsMemberActivationDialogOpen(!isMemberActivationDialogOpen);
  };

  const handleFilterInputChange = ({ target: { value } }) => {
    const onlyIntegerRegex = "^[0-9]*$";
    if (value.match(onlyIntegerRegex)) setFilterTextInput(value);
    setFilterTextInput(value);
  };

  async function handleDeleteWorker(id) {
    const deleteW =
      typeClient === "cnpj"
        ? await deleteWorkers({
            id: Number(id),
            user: clientUser,
            password: clientPassword,
          })
        : await deleteWorkers({ id: Number(id), token });

    if (deleteW) {
      setIsMemberActivationDialogOpen(!isMemberActivationDialogOpen);
      const allMembersFilter = allMembers.filter((member) => {
        return member.id !== Number(id);
      });
      setAllMembers(allMembersFilter);
      toast.success("Funcionário Deletado Com Sucesso!!");
    } else {
      toast.error("Erro ao Deletar Funcionário");
    }
  }

  const handleResetFilterButton = () => {
    setIsLoading(true);
    setCpfError(false);
    setFilterTextInput("");
  };

  useEffect(() => {
    setIsFirstRender(false);
    setIsMemberDrawerOpen(false);
    getAllMembers();
  }, []);

  useEffect(() => {
    if (!isFirstRender) getAllMembers();
  }, [membersPage]);

  const context = {
    handleFilterInputChange,
    filterTextInput,
    setFilterTextInput,
    handleResetFilterButton,
    cpfError,
  };

  return (
    <MembersContext.Provider value={context}>
      <Dialog
        open={isMemberActivationDialogOpen}
        onClose={handleMemberActivationDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Tem certeza dessa ação?
        </DialogTitle>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button color="error" onClick={handleMemberActivationDialog}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleDeleteWorker(idOnDelete);
            }}
          >
            Concordar
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
        <Stack spacing={3} mb={3} sx={{ width: "100%" }}>
          <Container maxWidth="lg" className="mb-6">
            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: { xs: "center", md: "space-between" },
                alignItems: "flex-start",
              }}
            >
              <Grid item xs={12} md={4}>
                <Stack spacing={2}>
                  <CustomButton
                    color="primary"
                    onClick={() => navigation("/new-worker")}
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      width: { xs: "100%", sm: "auto" },
                    }}
                    type="button"
                    variant="contained"
                  >
                    <Typography sx={{ lineHeight: 1.5 }} variant="button">
                      Cadastrar Funcionário
                    </Typography>
                    <CreateIcon sx={{ ml: 1 }} />
                  </CustomButton>
                </Stack>
              </Grid>
            </Grid>
          </Container>

          <CustomContainer>
            <Box sx={{ overflowX: "auto" }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ minWidth: { xs: "100px", sm: "150px" } }}>
                      CPF
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: { xs: "100px", sm: "150px" } }}>
                      Nome
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: { xs: "100px", sm: "150px" } }}>
                      Acesso
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: { xs: "80px", sm: "110px" } }}>
                      Editar
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: { xs: "80px", sm: "110px" } }}>
                      Excluir
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {!!allMembers.length &&
                    !isLoading &&
                    allMembers.map(({ id, cpf, nome, admin }) => (
                      <TableRow
                        key={id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          backgroundColor: `${cpf === memberSelectedCPF ? "#f5f5f5" : ""}`,
                        }}
                      >
                        <TableCell align="center">{cpf ? cpf : "-"}</TableCell>
                        <TableCell align="center">{nome ? nome : "-"}</TableCell>
                        <TableCell align="center">
                          {admin == "0"
                            ? "Colaborador"
                            : admin == "1"
                            ? "Técnico"
                            : "Administrador"}
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            name={cpf}
                            onClick={() => {
                              navigation("/edit-worker");
                              setEditCpf(cpf);
                              sessionStorage.setItem("editCpf", cpf);
                              setEditName(nome);
                              sessionStorage.setItem("editName", nome);
                              setEditId(id);
                              sessionStorage.setItem("editId", JSON.stringify(id));
                            }}
                            sx={{ mx: 1, p: 0 }}
                          >
                            <CreateIcon sx={{ width: 35 }} color="primary" />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            name={id}
                            onClick={handleMemberActivationDialog}
                            sx={{ mx: 1, p: 0 }}
                          >
                            <TiDelete size={30} color="red" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>

            {isLoading && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                  width: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            )}

            {isMembersNotFound && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                  width: "100%",
                }}
              >
                <Typography component="p" mt={3} variant="h4">
                  Funcionário não encontrado
                </Typography>
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 4,
                maxWidth: "100%",
              }}
            >
              <ButtonGroup size="small">
                <CustomButton
                  disabled={isLoading || membersPage === 0}
                  onClick={() => {
                    setIsLoading(true);
                    setMembersPage(0);
                  }}
                  variant="contained"
                >
                  <FirstPageRoundedIcon />
                </CustomButton>
                <CustomButton
                  disabled={isLoading || membersPage === 0}
                  onClick={() => {
                    if (Number(membersPage) > 0) {
                      setIsLoading(true);
                      setMembersPage((prev) => Number(prev) - 1);
                    }
                  }}
                  variant="contained"
                >
                  <NavigateBeforeRoundedIcon />
                </CustomButton>
                <CustomButton
                  disabled={isLoading || allMembers.length < 29}
                  onClick={() => {
                    setIsLoading(true);
                    setMembersPage((prev) => (Number(prev) + 1).toString());
                  }}
                  variant="contained"
                >
                  <NavigateNextRoundedIcon />
                </CustomButton>
              </ButtonGroup>
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  boxShadow: "0px 0px 15px 0px rgb(88 88 88 / 30%)",
                  display: "flex",
                  height: "40px",
                  justifyContent: "center",
                  ml: 1,
                  width: "40px",
                }}
              >
                <Typography color="primary" component="p" variant="h6">
                  {membersPage}
                </Typography>
              </Box>
            </Box>
          </CustomContainer>
        </Stack>
      </Box>
    </MembersContext.Provider>
  );
}
